import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  okay: () => __(translations.attachDirectoryForm.okay, 'Okay'),
  mergeWith: () => __(translations.attachDirectoryForm.mergeWith, 'Attach to'),
  title: () => __(translations.attachDirectoryForm.alertTitle, 'Attach Directory'),
  message: () => __(translations.attachDirectoryForm.alertMessage, 'Are you sure you want to attach this directory?'),
};
